import { Flex } from "@mantine/core";
import Container from "../components/common/Container";
import TodayShifts from "../components/Dashboard/TodayShifts";
import UpcomingBirthdays from "../components/Dashboard/UpcomingBirthdays";
import WeeklyAttendanceAnalysis from "../components/Dashboard/WeeklyAttendanceAnalysis";
import LiveActivity from "../components/Dashboard/LiveActivity";
import Filters from "../components/Dashboard/Filters";
import InfoBoxes from "../components/Dashboard/InfoBoxes";
import MissingToday from "../components/Dashboard/MissingToday";
import { FilterProvider } from "../context/DashboardFilterContext";

const Dashboard = () => {
  return (
    <FilterProvider>
      <Container>
        <Flex gap={22} direction={"column"}>
          <Flex h={84}>
            <Filters flex={1} />
          </Flex>
          <Flex gap={20} h={308}>
            <InfoBoxes flex={1} />
            <TodayShifts flex={1} />
          </Flex>
          <Flex h={476} gap={20}>
            <LiveActivity flex={5} />
            <MissingToday flex={3} />
          </Flex>
          <Flex h={412} gap={20}>
            <WeeklyAttendanceAnalysis flex={5} />
            <UpcomingBirthdays flex={4} />
          </Flex>
        </Flex>
      </Container>
    </FilterProvider>
  );
};

export default Dashboard;
